import React, { Fragment, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Chip,
  Breadcrumbs,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
	makeStyles,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Moment from "moment";
import MaterialTable from "../../../components/material_table";
import { useHistory } from "react-router-dom";
import {
  ACTUALIZAR_CONTRATO,
  ELIMINAR_CONTRATO,
  ACTUALIZAR_CONTRATO_BASICO,
} from "../../../constants/permissions";
import { redirecTo } from "../../../services/auth";
import { tienePermisosParaVerTodosContrato } from "../../../services/database/usuario";

import { obtenerItemsProcesos } from "../../adminProcesoEliminacion/requestItem";
import DetalleDeCierre from "../listaParaFinalizar/detalle_cierre";

function TablaContratos(props) {
  const {
    usuario,
    contratos,
    dialog_open,

    handle_eliminar,
    handle_cancelar,
    handle_export,
    handle_reload,
  } = props;

  const classes = style();
  const history = useHistory();
  const [openDialogoEstatus, setOpenDialogoEstatus] = useState(false);
  const [totalEstado, setTotalEstados] = React.useState([]);
  const [contratoSelect, setOpenSelect] = useState();

  const permisos = Array.from(usuario.permisos);
  const permisoActualizar = permisos.find(
    (p) => p.nombre === ACTUALIZAR_CONTRATO
  );

  const permisoEliminar = permisos.find((p) => p.nombre === ELIMINAR_CONTRATO);
  console.log(permisoEliminar);

  const permisoActualizarBasico = permisos.find(
    (p) => p.nombre === ACTUALIZAR_CONTRATO_BASICO
  );

  useEffect(() => {
    obtenerItemsProcesos()
      .then((result) => {
        setTotalEstados(result);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    handle_reload();
  }, [openDialogoEstatus]);

  const handleClickOpenDialog = (idContrato) => {
    console.log("open dialog");
    console.log(idContrato);
    setOpenSelect(idContrato);
    setOpenDialogoEstatus(true);
  };

  const handleClickCloseDialog = () => {
    console.log("close dialog");
    setOpenDialogoEstatus(false);
  };

  const generarEstadoContratoView = (estado) => {
    let color = ["#2ecc71", "#f1c40f", "#e67e22", "#c0392b"];
    let mapEstados = []
    if(totalEstado.length !==0){
      mapEstados = totalEstado.map((item) => {
        let resultMap = {};
        if (estado?.proceso_de_finalizacion) {
          resultMap = estado.proceso_de_finalizacion.find(
            (estado) => estado.id_proceso === item._id
          );
        }
  
        return {
          ...resultMap,
          ...item,
        };
      });
    }
    

    //
    let itemObligatorios = mapEstados.filter((item) => item.is_obligatorio);

    let puedeCerrar = itemObligatorios.every((item) => {
      let aux;

      typeof item.is_cerrado === "undefined"
        ? (aux = false)
        : (aux = item.is_cerrado);
      return aux === true;
    });

    //
    let cantFinalizados = mapEstados.filter((item) => item.is_cerrado);
    let per = (cantFinalizados.length * 100) / totalEstado.length===0?1:totalEstado.length;
    let index = 3;
    if (per < 30) {
      index = 3;
    } else if (per >= 31 && per <= 60) {
      index = 2;
    } else if (per >= 61 && per < 100) {
      index = 1;
    } else if (per >= 75) {
      if (puedeCerrar) {
        index = 0;
      } else {
        index = 1;
      }
    }

    return (
      <Chip
        onClick={() => handleClickOpenDialog(estado)}
        label={per.toFixed(1) + " % "}
        style={{ background: color[index], color: "#fff" }}
      />
    );
  };

  let columns = [
    {
      title: "Código Proyecto",
      field: "codigo",
      grouping: false,
      cellStyle: {
        fontSize: "0.9em",
        width: "15px",
      },
      render: (row) => generarCodigoContratoView(row.codigo),
    },
    // {
    //   title: "Estado de Cierre",
    //   field: "codigo",
    //   grouping: false,
    //   cellStyle: {
    //     fontSize: "0.9em",
    //     width: "15px",
    //   },
    //   render: (row) => generarEstadoContratoView(row),
    // },
    {
      title: "Gerencia",
      field: "gerencia_ref.sigla",
      cellStyle: {
        width: "7px",
      },
      render: (row) => generarCodigoGerenciaView(row),
    },
    {
      title: "Empresa",
      field: "sociedad_ref.nombre",
    },
    {
      title: "Contrato",
      field: "nombre",
    },
    {
      title: "Fecha de Cierre",
      field: "fecha_cierre_real",
      defaultSort: "desc",
      render: (row) => generarFechaView(row, "fecha_cierre_real"),
      hidden: false,
    },
    {
      title: "Cerrado por",
      field: "cerrado_por",
      render: (row) => generarCerradoPorView(row, "cerrado_por"),
    },
    {
      title: "Incio Proceso de Cierre",
      field: "inicio_proceso_de_finalizacion",
      render: (row) => generarFechaView(row, "inicio_proceso_de_finalizacion"),
    },
    {
      title: "Cierre inciado por",
      field: "incio_de_cierre_por",
      render: (row) => generarCerradoPorView(row, "incio_de_cierre_por"),
    },
    {
      title: "Fecha Inicio",
      field: "fecha_inicio",
      render: (row) => generarFechaView(row, "fecha_inicio"),
      hidden: true,
    },
    {
      title: "Fecha Est. Término",
      field: "fecha_termino_estimada",
      render: (row) => generarFechaView(row, "fecha_termino_estimada"),
    },
    {
      title: "Responsable",
      field: "responsable_ref.persona.nombre_completo",
      render: (row) => getEncargadoView(row),
    },
    {
      title: "Responsable Talana",
      field: "responsable_ref.persona.nombre_completo",
      render: (row) => getEncargadoTalanaView(row),
    },
    {
      title: "Cliente",
      field: "mandante_ref.nombre",
      render: (row) => generarMandantesView(row),
    },
  ];

  let actions = [
    (rowData) => ({
      icon: "edit",
      tooltip: "Editar",
      onClick: (event, row) => history.push(`/contrato/${row._id}`),
      iconProps: { style: { color: "#757575" } },
      iconProps: {
        style: {
          color:
            tienePermisosParaVerTodosContrato(usuario) ||
            permisoActualizar ||
            permisoActualizarBasico
              ? "#757575"
              : null,
        },
      },
      disabled:
        !(permisoActualizar || permisoActualizarBasico) &&
        rowData.responsable_ref.persona.usuario_id !== usuario.uid,
    }),

    // {
    //   icon: "edit",
    //   tooltip: "Editar",
    //   onClick: (event, row) => history.push(`/contrato/${row._id}`),
    //   iconProps: { style: { color: "#757575" } },
    //   iconProps: {
    //     style: {
    //       color:
    //         permisoActualizar || permisoActualizarBasico ? "#757575" : null,
    //     },
    //   },
    //   // hidden: !permisoActualizar,
    //   disabled: !(permisoActualizar || permisoActualizarBasico),
    // },

    (rowData) => ({
      icon: "email",
      tooltip: "Encuesta",
      onClick: (event, row) =>
        redirecTo(`https://encuestas.cydingenieria.com/envio_encuestas/${row._id}`),
      iconProps: { style: { color: "#757575" } },
      iconProps: {
        style: {
          color:
            tienePermisosParaVerTodosContrato(usuario) ||
            permisoActualizar ||
            permisoActualizarBasico
              ? "#757575"
              : null,
        },
      },
      disabled: tienePermisosParaVerTodosContrato(usuario)
        ? false
        : !(permisoActualizar || permisoActualizarBasico) &&
          rowData.responsable_ref.persona.usuario_id !== usuario.uid,
    }),
    // {
    //   icon: "email",
    //   tooltip: "Encuesta",
    //   onClick: (event, row) =>
    //     redirecTo(`https://encuestas.cydingenieria.com/envio_encuestas/${row._id}`),
    //   iconProps: { style: { color: "#757575" } },
    //   // hidden: !permisoEnviarEncuesta,
    //   disabled: !permisoEnviarEncuesta,
    // },
  ];
  console.log(openDialogoEstatus);
  return (
    <Fragment>
      <main>
        <Container maxWidth="xl" className={classes.main}>
          <Breadcrumbs separator=">">
            <Typography color="textPrimary">Módulo Contratos</Typography>
            <Typography color="textPrimary">Contratos Cerrados</Typography>
          </Breadcrumbs>
          <Container maxWidth="xl">
            <MaterialTable
              title="Contratos Cerrados"
              is_loading={!contratos}
              data={contratos}
              columns={columns}
              actions={actions}
              export_function={handle_export}
              fixedColumns={{ right: 0 }}
              exportar={true}
              options={{
                headerStyle: { position: "sticky", top: 0 },
                fixedColumns: {
                  right: 1,
                },
              }}
            />
          </Container>
          <Dialog open={dialog_open} disableBackdropClick disableEscapeKeyDown>
            <DialogTitle>Eliminar Contrato</DialogTitle>
            <DialogContent dividers>
              <Typography>
                Se debe confirmar la eliminación del contrato.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handle_eliminar}
                variant="contained"
                color="primary"
              >
                Eliminar
              </Button>
              <Button autoFocus onClick={handle_cancelar} color="primary">
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
        <DetalleDeCierre
          hideCierreContrato={true}
          openDialog={openDialogoEstatus}
          setOpenDialog={setOpenDialogoEstatus}
          onClickCloseDialog={handleClickCloseDialog}
          contrato={contratoSelect}
        />
      </main>
    </Fragment>
  );
}

/**
 * Método encargado de generar el CHIP con el código del contrato/proyecto.
 * @param {*} codigo Código del contrato/proyecto.
 */
function generarCodigoContratoView(codigo) {
  if (!codigo) {
    return <Chip label={"Sin Código"} color="primary" />;
  } else {
    return <Chip label={codigo} color="primary" />;
  }
}

/**
 * Método encargado de generar el CHIP con la sigla de la gerencia.
 * @param {*} data Datos del contrato.
 */
function generarCodigoGerenciaView(data) {
  let texto = "Sin Gerencia";
  if (typeof data === "string") {
    texto = data;
  } else if (typeof data === "object" && data.gerencia_ref) {
    texto = data.gerencia_ref.sigla;
  }
  return <Chip label={texto} variant="outlined" color="primary" />;
}

/**
 * Método encargado de generar el CHIP con foto y nombre del encargado.
 * @param {*} data Datos del contrato.
 */
function getEncargadoView(data) {
  let texto = "Sin Responsable";
  let foto = "";
  if (typeof data === "string") {
    texto = data;
  } else if (typeof data === "object" && data.responsable_ref) {
    texto = data.responsable_ref.persona.nombre_completo;
    foto = data.responsable_ref.persona.photo;
  }
  return (
    <div style={{ display: "flex", flexFlow: "row ", alignItems: "center" }}>
      <Avatar alt="Foto Encargado" src={foto} />
      <Box fontSize={13} m={1}>
        {texto}
      </Box>
    </div>
  );
}

function getEncargadoTalanaView(data) {
  let texto = "Sin Responsable";
  let foto = "";
  if (typeof data === "string") {
    texto = data;
  } else if (typeof data === "object" && data.responsable_admin_ref) {
    texto = data.responsable_admin_ref.persona.nombre_completo;
    foto = data.responsable_admin_ref.persona.photo;
  }
  return (
    <div style={{ display: "flex", flexFlow: "row ", alignItems: "center" }}>
      <Avatar alt="Foto Encargado" src={foto} />
      <Box fontSize={13} m={1}>
        {texto}
      </Box>
    </div>
  );
}

/**
 * Método encargado de formatear las fechas, si corresponde.
 * @param {*} fecha Fecha que será verificada y formateada.
 */
function generarFechaView(data, propiedad) {
  
  let texto = "Indefinida";
  if (data && typeof data === "string") {
    texto = data;
  } else if (data && Moment(data[propiedad]).year() === 2100) {
    texto = "Indefinido";
  } else if (data && data[propiedad]) {
    texto = Moment(data[propiedad]).format("DD/MM/YYYY");
  }
  return texto;
}

/**
 * Método encargado de generar el CHIP para mandantes.
 * @param {*} data Datos del contrato.
 */
function generarMandantesView(data) {
  let texto = "Sin Gerencia";
  if (typeof data === "string") {
    texto = data;
  } else if (typeof data === "object" && data.mandante_ref) {
    texto =
      data.mandante_ref.nombre.length < 25
        ? data.mandante_ref.nombre
        : data.mandante_ref.nombre.substring(0, 25) + "...";
  }
  return <Chip label={texto} variant="outlined" color="primary" />;
}

function generarCerradoPorView(data, propiedad) {
  let texto = "Sin Responsable";
  let foto = "";
  if (typeof data === "string") {
    texto = data;
  } else if (typeof data === "object" && data[propiedad]) {
    texto = data[propiedad].nombre;
    foto = data[propiedad].photoUrl;
  }
  return (
    <div style={{ display: "flex", flexFlow: "row ", alignItems: "center" }}>
      <Avatar alt="Foto Encargado" src={foto} />
      <Box fontSize={13} m={1}>
        {texto}
      </Box>
    </div>
  );
}
const style = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}));

export default TablaContratos;
